import {
  v4 as uuidv4
} from "uuid";

const music = () => {
  return [{
      name: "Spilled Water On Notes",
      cover: "https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072821_960_720.jpg",
      artist: "Chillin Wolfs",
      audio: "https://www.free-stock-music.com/music/chillin_wolf-spilled-water-on-notes.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Summer Vacation At Home",
      cover: "https://cdn.pixabay.com/photo/2016/09/29/13/08/planet-1702788_960_720.jpg",
      artist: "Patchworker",
      audio: "https://www.free-stock-music.com/music/friendzoned-summer-vacation-at-home.mp3",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Close To You",
      cover: "https://cdn.pixabay.com/photo/2018/11/17/22/15/tree-3822149_960_720.jpg",
      artist: "PYC Music",
      audio: "https://www.free-stock-music.com/music/pyc-music-close-to-you.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Coffee Break",
      cover: "https://cdn.pixabay.com/photo/2015/11/11/03/47/evening-1038148_960_720.jpg",
      artist: "Pyrosion",
      audio: "https://www.free-stock-music.com/music/pyrosion-coffee-break.mp3",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Chill",
      cover: "https://cdn.pixabay.com/photo/2017/05/10/15/05/himalayas-2301040_960_720.jpg",
      artist: "Sakura Hz",
      audio: "https://www.free-stock-music.com/music/sakura-hz-chill.mp3",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Flourish",
      cover: "https://cdn.pixabay.com/photo/2019/02/26/04/04/mountain-4021090_960_720.jpg",
      artist: "Purrple Cat",
      audio: "https://www.free-stock-music.com/music/purrple-cat-flourish.mp3",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Midnight Snack",
      cover: "https://cdn.pixabay.com/photo/2018/07/05/22/16/panorama-3519309_960_720.jpg",
      artist: "Purrple Cat",
      audio: "https://www.free-stock-music.com/music/purrple-cat-midnight-snack.mp3",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Another Few Weeks",
      cover: "https://cdn.pixabay.com/photo/2017/10/29/15/58/yorkshire-2900064_960_720.jpg",
      artist: "BatchBug",
      audio: "https://www.free-stock-music.com/music/batchbug-another-few-weeks.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Another Few Weeks",
      cover: "https://cdn.pixabay.com/photo/2019/08/02/02/02/beach-4378548_960_720.jpg",
      artist: "BatchBug",
      audio: "https://www.free-stock-music.com/music/batchbug-another-few-weeks.mp3",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Another Few Weeks",
      cover: "https://cdn.pixabay.com/photo/2016/03/09/09/42/forest-1245951_960_720.jpg",
      artist: "BatchBug",
      audio: "https://www.free-stock-music.com/music/batchbug-another-few-weeks.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Another Few Weeks",
      cover: "https://cdn.pixabay.com/photo/2018/04/12/18/13/sunset-3314275_960_720.jpg",
      artist: "BatchBug",
      audio: "https://www.free-stock-music.com/music/batchbug-another-few-weeks.mp3",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Another Few Weeks",
      cover: "https://cdn.pixabay.com/photo/2014/05/03/00/09/landscape-336542_960_720.jpg",
      artist: "BatchBug",
      audio: "https://www.free-stock-music.com/music/batchbug-another-few-weeks.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "At Red's House",
      cover: "https://cdn.pixabay.com/photo/2019/04/27/23/09/beach-4161593_960_720.jpg",
      artist: "Eli Gold",
      audio: "https://www.free-stock-music.com/music/eli-gold-at-reds-house.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Relax, Man",
      cover: "https://cdn.pixabay.com/photo/2016/06/20/03/15/pier-1467984_960_720.jpg",
      artist: "Le Gang",
      audio: "https://www.free-stock-music.com/music/le-gang-relax-man.mp3",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Sundown",
      cover: "https://cdn.pixabay.com/photo/2017/02/08/12/46/moon-2048727_960_720.jpg",
      artist: "Schematist",
      audio: "https://www.free-stock-music.com/music/schematist-sundown.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Day's End",
      cover: "https://cdn.pixabay.com/photo/2016/11/25/15/14/landscape-1858602_960_720.jpg",
      artist: "Purrple Cat",
      audio: "https://www.free-stock-music.com/music/purrple-cat-days-end.mp3",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "This Valley Of Untold Emotion",
      cover: "https://cdn.pixabay.com/photo/2017/04/16/10/02/star-trails-2234343_960_720.jpg",
      artist: "Chillin Wolf",
      audio: "https://www.free-stock-music.com/music/chillin_wolf-this-valley-of-untold-emotion.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Surface Level",
      cover: "https://cdn.pixabay.com/photo/2016/06/20/03/21/rainbow-1467988_960_720.jpg",
      artist: "Schematist",
      audio: "https://www.free-stock-music.com/music/schematist-surface-level.mp3",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "11 PM",
      cover: "https://cdn.pixabay.com/photo/2017/02/01/22/02/mountain-landscape-2031539_960_720.jpg",
      artist: "Butch Bug",
      audio: "https://www.free-stock-music.com/music/batchbug-11-pm.mp3",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "So This Is Why I Love You",
      cover: "https://cdn.pixabay.com/photo/2015/04/23/22/01/mountains-736886_960_720.jpg",
      artist: "Barradeen",
      audio: "https://www.free-stock-music.com/music/barradeen-so-this-is-why-i-love-you.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Forget-Me-Not",
      cover: "https://cdn.pixabay.com/photo/2015/02/24/15/41/dog-647528_960_720.jpg",
      artist: "Purrple Cat",
      audio: "https://www.free-stock-music.com/music/purrple-cat-forget-me-not.mp3",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Green",
      cover: "https://cdn.pixabay.com/photo/2016/12/27/21/03/lone-tree-1934897_960_720.jpg",
      artist: "Voitrax",
      audio: "https://www.free-stock-music.com/music/yoitrax-green.mp3",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Moonlit Walk",
      cover: "https://cdn.pixabay.com/photo/2017/01/14/13/59/castelmezzano-1979546_960_720.jpg",
      artist: "Purrple Cat",
      audio: "https://www.free-stock-music.com/music/purrple-cat-moonlit-walk.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "In One Place",
      cover: "https://cdn.pixabay.com/photo/2013/11/15/13/57/road-210913_960_720.jpg",
      artist: "Barradeen",
      audio: "https://www.free-stock-music.com/music/barradeen-in-one-place.mp3",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Lonely Soul",
      cover: "https://cdn.pixabay.com/photo/2017/12/03/22/11/winter-landscape-2995987_960_720.jpg",
      artist: "Rexlambo",
      audio: "https://www.free-stock-music.com/music/rexlambo-lonely-soul.mp3",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
  ];
}

export default music;
